import React, { useEffect, useState } from "react";
import { Modal, Button, Card, Form } from "react-bootstrap";
import { LiaIdCard } from "react-icons/lia";
import { FaUpload } from "react-icons/fa6";

import Swal from "sweetalert2";

const EditAddressProofTypeModal = ({ show, onHide, kycDoc, selectedProofType, setSelectedProofType, setModalShowAddressForm, setModalShowEditAddressType }) => {

    console.log("selectedProofType", selectedProofType, kycDoc)
    const [clientAddressProof, setClientAddressProof] = useState([]);
  



    const handleCardClick = (proofType) => {
        if (selectedProofType === null) {
            setSelectedProofType(proofType);
            if (proofType === "passport" || proofType === "voterid") {
                setModalShowAddressForm(true)
            }
            setModalShowEditAddressType(false)
        }
    };


    const cardStyle = (type) => ({
        backgroundColor: selectedProofType === type ? "#d4edda" : "#fff",
        textTransform: 'capitalize',
        // cursor: selectedProofType ? "pointer" : "not-allowed",
        opacity: selectedProofType && selectedProofType !== type ? 0.5 : 1,


    });

    // useEffect(() => {
    //         setModalShowAddressForm(true)
    // },[selectedProofType])


    return (
        <>
            <Modal size={'lg'} centered show={show} onHide={onHide}>
                <Modal.Header closeButton style={{ backgroundColor: "#fff" }}>
                    <Modal.Title className="fw-normal">Select Address Proof Type</Modal.Title>
                </Modal.Header>
                <Modal.Body closeButton>
                    <div className="d-flex justify-content-between  gap-1 align-items-center ">
                        {["passport", "voterid", "dl", "aadhaar"].map((type) => (
                            <Card
                                key={type}
                                className={`border-1   text-center  w-100 `}
                                style={cardStyle(type)}
                                onClick={() => handleCardClick(type)}
                            >
                                <Card.Body>
                                    <p className="fw-normal fs-2 capitalize refer">{type}</p>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>

                    {selectedProofType === null && (
                        <>
                            {

                                clientAddressProof.length > 0 && clientAddressProof[0].sinzey_doc_url_front && (

                                    <div>
                                        <h5 className="text-success text-center">
                                            Uploaded Address Proof
                                        </h5>
                                        <div className="d-flex justify-content-between mb-4">
                                            <Card className="upload-card">
                                                <Card.Body>
                                                    <Card.Img
                                                        variant="top"
                                                        src={clientAddressProof[0].sinzey_doc_url_front}
                                                        alt="Front Image"
                                                        className="w-100"
                                                    />
                                                </Card.Body>
                                                <Card.Footer>First Page</Card.Footer>
                                            </Card>
                                            <Card className="upload-card">
                                                <Card.Body>
                                                    <Card.Img
                                                        variant="top"
                                                        src={clientAddressProof[0].sinzey_doc_url_back}
                                                        alt="Back Image"
                                                        className="w-100"
                                                    />
                                                </Card.Body>
                                                <Card.Footer>Last Page</Card.Footer>
                                            </Card>
                                        </div>
                                    </div>
                                )}
                        </>
                    )}


                </Modal.Body>

            </Modal>
        </>
    );
};

export default EditAddressProofTypeModal;
